import { render } from "./BoardModerator.vue?vue&type=template&id=c925c4b4"
import script from "./BoardModerator.vue?vue&type=script&lang=js"
export * from "./BoardModerator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__